"use client";

import Script from "next/script";
import { useSyncExternalStore } from "react";
const subscribe = () => () => {};
function requested() {
  try {
    const language = localStorage.getItem("b_laundry_gt_lang");
    return !!language && language !== "en";
  } catch { return /(?:^|;\s*)googtrans=\/en\/(?!en(?:;|$))[^;]+/.test(document.cookie); }
}
/** Translation is a requested feature; do not contact Google on every visit. */
export function TranslationBootstrap() {
  const enabled = useSyncExternalStore(subscribe, requested, () => false);
  if (!enabled) return null;
  return <>
    <div id="google_translate_element" style={{ position: "absolute", top: -9999, left: -9999 }} />
    <Script id="translation-init" strategy="afterInteractive">{`function googleTranslateElementInit() {
      new google.translate.TranslateElement({pageLanguage:'en',autoDisplay:false,layout:google.translate.TranslateElement.InlineLayout.SIMPLE},'google_translate_element');
    }`}</Script>
    <Script src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit" strategy="afterInteractive" />
  </>;
}
